import Splide from '@splidejs/splide';
export const init = () => {
    if (document.querySelector('.carousel_type-6')) {
        const carousel6 = document.querySelectorAll('.carousel_type-6');

        let data = [];
        // Source hide/render logic 
        const source_el_all = document.querySelectorAll('.js-source-type-3');

        if(source_el_all) {
           
            var render_source = function(sliderId, itemId) {
                if(data[sliderId].sourceStrings.length) {
                    setTimeout(function() {
                        data[sliderId].sourceStringsElements[0].textContent = data[sliderId].sourceStrings[itemId];
                    }, 280);
                }
            }
        }
         
        carousel6.forEach((item, index) => { 
            if(item.parentElement.classList.contains('b-customer-project-slider')) {
                const splideCarousel6 = new Splide(item, {
                    interval: 2000,
                    perPage: 1,
                    perMove: 1,  
                    drag: false,
                    pagination: true,
                    arrows: false,
                    classes: {
                        pagination: 'splide__pagination g-pagination__type-1',
                    },
                },);
                              
                const splideCarousel6Sub = new Splide(item.nextElementSibling, {
                    rewind: true,
                    fixedWidth: 169,
                    fixedHeight: 95,
                    gap: 19, 
                    arrows: false,
                    isNavigation: true,   
                    pagination: false,              
                    cover: true,
                    dragMinThreshold: {
                        mouse: 4,
                        touch: 10,
                    },
                    breakpoints: {
                        640: {
                            fixedWidth: 160,
                            fixedHeight: 100,
                            gap: 8,
                        },
                    },
                });

                splideCarousel6.sync(splideCarousel6Sub);
                splideCarousel6.mount();
                splideCarousel6Sub.mount(); 

                data = [
                    ...data,
                    {
                        sourceStrings: [...item.querySelectorAll('.data-source-type-3')].map(function(cur){
                            return cur.textContent; 
                        }),
                        sourceStringsElements: [item.querySelector('.data-source-type-3') && item.querySelector('.data-source-type-3').closest('.content-image, .b-customer-project-slider').querySelector('.js-source-type-3')],
                    }
                ];
                
                render_source(index, 0); 
    
                splideCarousel6.on( 'move', (newIndex) => { 
                    if(source_el_all) {
                        render_source(index, newIndex);
                    } 
                });
                if (splideCarousel6.length > 1) {
                    const { Controller } = splideCarousel6.Components;
                    const arrowLeft = item.querySelector('.button--prev');
                    const arrowRight = item.querySelector('.button--next');
                
                    if (!arrowLeft || !arrowRight) return;
                
                    const toggleArrows = (index) => {
                        const atStart = index === 0;
                        const atEnd = index === Controller.getEnd();
                
                        arrowLeft.classList.toggle('u-js-hide', atStart);
                        arrowRight.classList.toggle('u-js-hide', atEnd);
                    };
                
                    splideCarousel6.on('move', toggleArrows);
                    toggleArrows(splideCarousel6.index); // set initial state
                
                    arrowLeft.addEventListener('click', () => Controller.go('<'));
                    arrowRight.addEventListener('click', () => Controller.go('>'));
                }
            } else {
                const splideCarousel6 = new Splide(item, {
                    arrows: false,
                    pagination: false, 
                    interval: 2000,
                    perPage: 1,
                    perMove: 1,  
                    drag: false,
                    speed: 1000
                },);
                              
                const splideCarousel6Sub = new Splide(item.nextElementSibling, {
                    rewind: true,
                    fixedWidth: 169,
                    fixedHeight: 95,
                    gap: 19, 
                    arrows: false,
                    isNavigation: true,                 
                    pagination: false,
                    cover: true,
                    dragMinThreshold: {
                        mouse: 4,
                        touch: 10,
                    },
                    breakpoints: {
                        640: {
                            fixedWidth: 160,
                            fixedHeight: 100,
                        },
                    },
                });
                splideCarousel6.sync(splideCarousel6Sub);
                splideCarousel6.mount();
                splideCarousel6Sub.mount(); 

                if (splideCarousel6.length > 1) {
                    const { Controller } = splideCarousel6.Components;
                    const arrowLeft = item.querySelector('.button--prev');
                    const arrowRight = item.querySelector('.button--next');
          
                    splideCarousel6.on('move', (newIndex) => {
                        switch (newIndex) { 
                            case 0: 
                                arrowLeft.classList.add('u-js-hide'); 
                                arrowRight.classList.remove('u-js-hide');
                                break;
                            case Controller.getEnd():
                                arrowRight.classList.add('u-js-hide');  
                                arrowLeft.classList.remove('u-js-hide');
                                break;
                            default:
                                arrowLeft.classList.remove('u-js-hide');
                                arrowRight.classList.remove('u-js-hide');  
                        } 
                    });
                    //console.log(arrowLeft)
                    arrowLeft.addEventListener('click', () => Controller.go('<'));
                    arrowRight.addEventListener('click', () => Controller.go('>'));
                  }

                if (splideCarousel6.length <= 1) {
                    item.nextElementSibling.firstElementChild.classList.add('hidden');
                }
                data = [
                    ...data,
                    {
                        sourceStrings: [...item.querySelectorAll('.data-source-type-3')].map(function(cur){
                            return cur.textContent; 
                        }),
                        sourceStringsElements: [item.querySelector('.data-source-type-3') && item.querySelector('.data-source-type-3').closest('.content-image, .b-customer-project-slider').querySelector('.js-source-type-3')],
                    }
                ];
                
                render_source(index, 0); 
    
                splideCarousel6.on( 'move', (newIndex) => { 
                    if(source_el_all) {
                        render_source(index, newIndex);
                    } 
                });
            } 
        }) 
    }

   
}